// FinOps uses one module route and selects its visible view with `?tab=`.
export const FINOPS_BASE_PATH = '/finops';
export const FINOPS_TAB_PARAM = 'tab';
export const DEFAULT_FINOPS_TAB = 'overview';
export const FINOPS_TABS = ['overview', 'ai-cost-optimization', 'cloud-cost-management-stages'];

export function finOpsTabPath(tab = DEFAULT_FINOPS_TAB, extraParams = undefined) {
  const params = new URLSearchParams(extraParams);
  params.set(FINOPS_TAB_PARAM, FINOPS_TABS.includes(tab) ? tab : DEFAULT_FINOPS_TAB);
  return `${FINOPS_BASE_PATH}?${params.toString()}`;
}

export const FINOPS_TAB_PATHS = {
  overview: finOpsTabPath('overview'),
  aiCostOptimization: finOpsTabPath('ai-cost-optimization'),
  cloudCostManagementStages: finOpsTabPath('cloud-cost-management-stages'),
};

export function resolveFinOpsTab(search = '') {
  const tab = new URLSearchParams(search).get(FINOPS_TAB_PARAM);
  return FINOPS_TABS.includes(tab) ? tab : DEFAULT_FINOPS_TAB;
}
